export enum LayoutPresetType {
	ThreePane = 'three-pane',
	TwoPaneGantt = 'two-pane-gantt',
	TwoPaneMap = 'two-pane-map',
}

export type LayoutPresetId = LayoutPresetType;

export enum LayoutPane {
	RouteList = 'routeList',
	Gantt = 'gantt',
	Map = 'map',
}

export type PaneId = LayoutPane;

export interface PaneState {
	id: PaneId;
	visible: boolean;
	size: number;
}

export interface LayoutPreset {
	activePresetId: LayoutPresetId;
	topPanes: PaneState[];
	taskBankSize: number;
}

export interface StoredLayoutPreference {
	schemaVersion: number;
	activePresetId: LayoutPresetId;
}

export const DEFAULT_PRESET_ID: LayoutPresetId = LayoutPresetType.ThreePane;
export const LAYOUT_SCHEMA_VERSION = 1;
export const LAYOUT_STORAGE_KEY = 'dp.dashboard.layout';

// TaskBank size is held at 40 so the current landing split (top 60 / TaskBank 40)
export const LAYOUT_PRESETS: Record<LayoutPresetId, LayoutPreset> = {
	[LayoutPresetType.ThreePane]: {
		activePresetId: LayoutPresetType.ThreePane,
		topPanes: [
			{ id: LayoutPane.RouteList, visible: true, size: 40 },
			{ id: LayoutPane.Gantt, visible: true, size: 30 },
			{ id: LayoutPane.Map, visible: true, size: 30 },
		],
		taskBankSize: 40,
	},
	[LayoutPresetType.TwoPaneGantt]: {
		activePresetId: LayoutPresetType.TwoPaneGantt,
		topPanes: [
			{ id: LayoutPane.RouteList, visible: true, size: 65 },
			{ id: LayoutPane.Gantt, visible: true, size: 35 },
			{ id: LayoutPane.Map, visible: false, size: 0 },
		],
		taskBankSize: 40,
	},
	[LayoutPresetType.TwoPaneMap]: {
		activePresetId: LayoutPresetType.TwoPaneMap,
		topPanes: [
			{ id: LayoutPane.RouteList, visible: true, size: 65 },
			{ id: LayoutPane.Gantt, visible: false, size: 0 },
			{ id: LayoutPane.Map, visible: true, size: 35 },
		],
		taskBankSize: 40,
	},
};
